module.exports = __webpack_public_path__ + "img/hr-dry-dirt.34bceb4b.png";